import React from 'react';
import { NavLink } from "react-router-dom";

function PickProduct() {
  return (
		  <div className="fullwidth dark">
			  <div className="row">
				  <div className="twelve columns">
					  <div className="row">
						  <div className="four columns">
							  <h2>Pick a Product</h2>
							  <hr className="gray"/>
								  <p>If you typed a web address in your browser please check that it was correct. If you were looking for products and services, provided by our company, please click a corresponding link.</p>
						  </div>
						  <div className="four columns">
							  <ul className="arrow">
								  <li><NavLink to="/en/">Home Page</NavLink></li>
								  <li><NavLink to="/en/dedicated-servers-switzerland">Dedicated Servers</NavLink></li>
							  </ul>
						  </div>
						  <div className="four columns">
							  <ul className="arrow">
								  <li><NavLink to="/en/confidential-servers-switzerland">Confidential Computing</NavLink></li>
							  </ul>
						  </div>
					  </div>
				  </div>

			  </div>
		  </div>
  );
}
 
export default PickProduct;
